import React, { useState } from 'react';
import { uploadAPI } from '../../../services/api';

const ImageUploader = ({ value, onChange, label = 'Image' }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setError('Please select an image file');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      setError('Image size must be less than 5MB');
      return;
    }

    setError('');
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await uploadAPI.uploadImage(formData);
      if (response.data.success) {
        // Construct full URL
        const base = process.env.NODE_ENV === 'production' 
          ? window.location.origin 
          : (process.env.REACT_APP_API_URL || 'http://localhost:5010/api').replace(/\/api\/?$/, '');
        const imageUrl = `${base}${response.data.url}`;
        onChange(imageUrl);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          {label}
        </label>
      )}
      <div className="space-y-2">
        {value && (
          <div className="relative inline-block">
            <img
              src={value}
              alt="Preview"
              className="h-32 w-auto rounded-lg border border-gray-300 dark:border-gray-600"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <button
              type="button"
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
              onClick={() => onChange('')}
            >
              ✕
            </button>
          </div>
        )}
        <div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            className="block w-full text-sm text-gray-500 dark:text-gray-400
              file:mr-4 file:py-2 file:px-4
              file:rounded-full file:border-0
              file:text-sm file:font-semibold
              file:bg-primary-50 file:text-primary-700
              hover:file:bg-primary-100
              dark:file:bg-primary-900 dark:file:text-primary-300
              cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            id={`upload-${label}`}
          />
          {uploading && (
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">Uploading...</p>
          )}
          {error && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
